import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'status'
})
export class StatusPipe implements PipeTransform {
  transform(value: number): string {
    switch (value) {
      case 0:
        return 'Inactif';
      case 1:
        return 'Actif';
      case 2:
        return 'Attente';
      default:
        return 'Inconnu';
    }
  }
}